import { render, staticRenderFns } from "./SettingPanel.vue?vue&type=template&id=be76bd60&scoped=true&"
import script from "./SettingPanel.vue?vue&type=script&lang=js&"
export * from "./SettingPanel.vue?vue&type=script&lang=js&"
import style0 from "./SettingPanel.vue?vue&type=style&index=0&id=be76bd60&prod&lang=stylus&"
import style1 from "./SettingPanel.vue?vue&type=style&index=1&id=be76bd60&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be76bd60",
  null
  
)

export default component.exports